import { ReactNode } from 'react';
import { Phone } from 'lucide-react';
import Navigation from './Navigation';
import Footer from './Footer';
import { CONTACT_INFO } from '../constants/contact';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-grow pb-20 md:pb-0">
        {children}
      </main>
      <Footer />

      {/* Sticky Call Button for Mobile */}
      <a
        href={`tel:${CONTACT_INFO.phone}`}
        className="sticky-call-button md:hidden"
        aria-label={`Call ${CONTACT_INFO.phoneDisplay}`}
      >
        <Phone className="w-5 h-5" />
        <span>Call Now - Initial Consultation</span>
      </a>
    </div>
  );
}
